// This file is auto-generated via CI, do not edit by hand!
export enum FeatureToggles {
  FEAT_01_DEFAULT = '01_Default',
  FEAT_01_AVALLINIEN_S = '01_Avallinien_S',
  FEAT_01_AVALLINIEN_M = '01_Avallinien_M',
  FEAT_01_AVALLINIEN_L = '01_Avallinien_L',
}
